export default __webpack_public_path__ + "static/media/PreviewOverlayV6.3986e363.png";